import React, { useEffect, useState } from 'react';
import { BQLink } from '../../../../atoms/bqlink';
import { ArrowRightIcon, FourStarIcon, TextBoxIcon } from '../../../../atoms/material-icons';
import { connect } from 'react-redux';
import EmptyState from '../empty-state';
import './stock-research-reports.m.css';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { contentClick, loadMoreInteraction } from '../../../../../helpers/datalayer-utils';

const StockResearchReports = ({ companyName, features, widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [researchReports, setResearchReports] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const userData = useSelector((state) => get(state, ["userData"]));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  const getReports = async () => {
    try {
      let list = null;

      // Check if companyName is available
      if (companyName) {
        const companyList = await fetch(
          `${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&allfields=${encodeURIComponent(companyName)}&pagesize=7&${NDTV_SEARCH_API_CONFIG?.research_param}`
        );
        list = await companyList?.json();
      }

      // If no data is returned or companyName is not available, call the fallback API
      if (!list?.results?.length) {
        const response = await fetch(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=7&${NDTV_SEARCH_API_CONFIG?.research_param}`);
        const data = await response.json();
        setResearchReports(data?.results || []);
      } else {
        setResearchReports(list?.results || []);
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  useEffect(() => {
    const fetchReports = async () => {
      setInitialLoading(true);
      await getReports();
      setInitialLoading(false);
    };

    fetchReports();
  }, [companyName, features?.sectionId]);

  useEffect(() => {
    const interval = setInterval(() => {
      getReports();
    }, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, [features?.sectionId]);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="main-stock-container">
      <div styleName="header-title-container">
        <TextBoxIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">RESEARCH REPORTS</h2>
      </div>
      {researchReports?.length === 0 ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          <div styleName="research-content">
            <div styleName="headline-container">
              {researchReports?.slice(0, 7).map((news, index) => {
                return (
                  <div
                    key={news.id || index}
                    onClick={() => contentClick(userData, news, pageType)}
                    styleName="report-content"
                  >
                    <BQLink href={new URL(news?.link).pathname}>
                      <h3 styleName="item-headline">{news?.title}</h3>
                      <span styleName="author-name">
                        {news?.['author_byline']}
                        <span className="exclusive-icon">
                          <FourStarIcon color="#CE9445" size="14px" />
                        </span>
                      </span>
                    </BQLink>
                  </div>
                );
              })}
            </div>
          </div>
          <a
            styleName="show-all-reports"
            href={`/research-reports${widgetParam}`}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              loadMoreInteraction('Read More', userData, pageType, 'stock research reports')
            }
          >
            Read More <ArrowRightIcon color={'#d01e51'} styleName="tab-icon" />
          </a>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  features: get(state, ['qt', 'config', 'features', 'researchReportSection'], {}),
});

export default connect(mapStateToProps)(StockResearchReports);
